export default "__VITE_ASSET__BUC5HTIR__"